/**
 * @fileoverview LabelRenderer component for the Storyteller web application.
 * Renders a label for a form element.
 *
 * @example
 * // Basic usage
 * <LabelRenderer text="Label text" />
 */

import { LabelProps } from '@jsonforms/core'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { VanillaRendererProps, withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import { Text } from '../../../typography/Typography'

/**
 * @function LabelRenderer
 * @description Component for rendering a label for a form element.
 * @param {LabelProps & VanillaRendererProps} props - The props for the LabelRenderer component.
 * @returns {JSX.Element} The LabelRenderer component.
 */
function LabelRenderer(props: LabelProps & VanillaRendererProps) {
    const { text } = props
    return <Text>{text}</Text>
}

export default withVanillaControlProps(withJsonFormsLabelProps(LabelRenderer))
